import React, { useEffect, useState } from 'react';
import api from "~/services/api";
import { Label, Input, Select, TextArea } from "~/componentes/CustomForm";

import { Container } from "./styles";
import CustomScrollBar from "~/componentes/CustomScrollBar";
import { Materialize } from "~/styles/materializeGrid";
import { SLModalFooter } from "~/pages/Sistema/componentes/SistemaList";
import ShowConfirmacao from "~/utils/ShowConfirmacao";

function CreateEditContent({ mountedData }) {
  const [processosProdutos, setProcessos] = useState([]);
  const [processosProduto, setProcesso] = useState({});

  const [ativo, setAtivo] = useState(
    !mountedData ? 'true' : mountedData?.ativo ? 'true' : 'false',
  );

  useEffect(() => {
    api.get("/signed/empresa/gestorprojeto/catalogo/entidades", { params: { ativo: 1 } })
      .then(response => setProcessos(response.data));

  }, []);

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let thisData = {
          ...data,
          ...(mountedData?.id ? { id: mountedData?.id } : {}),
          ativo: ativo === "true" ? true : false,
        }
        let response;
        if (mountedData?.id)
          response = await api.put("/signed/empresa/gestorprojeto/gerencia/produto", thisData);
        else
          response = await api.post("/signed/empresa/gestorprojeto/gerencia/produto", thisData);

        if (response?.status === 200) {
          closeReload && closeReload();
        }
        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao ${mountedData?.id ? "atualizar" : "cadastrar"} esse Produto, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja ${mountedData?.id ? "atualizar" : "cadastrar"} esse Produto?`,
        successModal: `Produto ${mountedData?.id ? "atualizado" : "cadastrado"} com sucesso!`,
      }
    );
  }

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row header">
          <p className="h-descricao">
            Preencha as informações corretamente, e se atente ao (*) pois são campos obrigatórios
          </p>
        </div>
        <div className="row">
          <Label title="Título *" className="col s12 m6 l3">
            <Input name="titulo" defaultValue={mountedData?.titulo} />
          </Label>
          <Label title="Produto *" className="col s12 m6 l2">
            <Select
              required="true"
              isString
              // list={{ list: produtos, value: "titulo", label: "titulo" }}
              name="serviço"
              firstOption
              defaultValue={mountedData?.serviço}
            />
          </Label>
          <Label title="Ativo *" className="col s12 m6 l2">
            <Select
              required="true"
              isString
              list={{
                list: [
                  { id: 'true', titulo: 'Sim' },
                  { id: 'false', titulo: 'Não' },
                ],
                value: 'id',
                label: 'titulo',
              }}
              name="ativo"
              defaultValue={mountedData?.ativo?.toString()}
              onChange={e => {
                const v = e.currentTarget.value || 'true';
                setAtivo(v);
              }}
            />
          </Label>
        </div>
      </Materialize>
    </Container>
  );
}

export default CreateEditContent;
